
const logo = require('@/assets/logo.svg');
import {Vue, Component} from 'vue-property-decorator';
import {nil} from '@/common';
import {FeathersVuexFindAll} from '@/utils';

@Component({
    components: {},
})
export default class VendorMixin extends Vue {

    public vendorAddress(vendor): string {
        if (nil(vendor)) {
            return '';
        }
        const {address} = vendor;
        const {city, state} = address;
        const cityText = nil(city) ? '' : city;
        const stateText = nil(state) ? '' : state;

        return `${cityText} ${stateText}`;
    }

    public vendorTier(vendor): string {
        if (nil(vendor)) {
            return 'A Pro';
        }
        const {tierModel} = vendor;
        if (nil(tierModel)) {
            return 'A Pro';
        }
        const {name: tierName} = tierModel;
        const tierText = (nil(tierName)) ? '' : tierName;
        return `A ${tierText} Pro`;
    }

    public vendorImage(vendor) {
        if (nil(vendor) || nil(vendor.profileImageModel)) {
            return logo;
        }
        if (nil(vendor.profileImageModel.thumb)) {
            return vendor.profileImageModel.file;
        }
        return vendor.profileImageModel.thumb;
    }

    public async vendorWorkImages(vendor) {
        if (nil(vendor) || nil(vendor.workImages, true)) {
            return [];
        }
        return await FeathersVuexFindAll(this.$FeathersVuex.Upload, {
            query: {
                _id: {$in: vendor.workImages},
            },
        });
    }
    public async vendorReviews(vendor) {
        if (nil(vendor) || nil(vendor.reviews) || vendor.reviews.length === 0) {
            return [];
        }
        return await FeathersVuexFindAll(this.$FeathersVuex.Review, {
            query: {
                _id: {$in: vendor.reviews},
            },
        });
    }
}
